import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { INTERNATIONAL_PHONE_CODE, PHONE_LENGTH } from 'src/app/core/config';
import { APP_ROUTES } from 'src/app/core/config/routes';
import { USER_TYPES } from 'src/app/core/enums';
import { LayoutService } from 'src/app/shared/services/layout.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  phoneCode = INTERNATIONAL_PHONE_CODE;
  phoneLength: number = PHONE_LENGTH;
  APP_ROUTES = APP_ROUTES;

  componentDestroyed$ = new Subject<boolean>();
  isDemoMode: boolean;

  userTypes = USER_TYPES;
  selectedType: string = this.userTypes.BUYER; // Default to buyer/seller

  constructor(
    private authService: AuthService,
    private sharedService: SharedService,
    private router: Router,
    private toastr: ToastrService,
    private layoutService: LayoutService,
    private activatedRoute: ActivatedRoute,
  ) {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    this.activatedRoute.queryParams.subscribe(params => {
      if (params['type']) {
        this.setRegisterType(params['type']);
      }
    });
  }

  ngOnInit(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    this.initializeForm();
    this.sharedService
      .getDemoStatus()
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((status) => {
        this.isDemoMode = status;
      });
  }

  initializeForm() {
    this.loginForm = new FormGroup({
      phoneNumber: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(this.phoneLength),
          Validators.minLength(this.phoneLength)
        ]
      })
    });
  }

  showPasswordField(): boolean {
    return [
      this.userTypes.TRANSPORTER,
      this.userTypes.TRANSPORTER_AGENT,
      this.userTypes.TRANSPORTER_COMPANY,
      this.userTypes.CONTROLLER,
      this.userTypes.MARKETER
    ].includes(this.selectedType as any);
  }

  onSubmit() {
    console.log(this.loginForm.valid);
    console.log(this.loginForm.value);


    const requestData = {
      ...this.loginForm.value,
      phoneNumber: this.phoneCode + this.loginForm.value.phoneNumber,
      pairingCode: this.loginForm.value.pairingCode
    };
    if (this.selectedType != this.userTypes.MARKETER && this.selectedType != this.userTypes.CONTROLLER && this.selectedType != this.userTypes.TRANSPORTER_AGENT && this.selectedType != this.userTypes.TRANSPORTER && this.selectedType != this.userTypes.TRANSPORTER_COMPANY) {
      this.authService.sendOtp(this.loginForm.value.phoneNumber, this.selectedType).subscribe(
        (response) => {
          if (response) {
            this.toastr.success('أرسلنا رمز التفعيل إلى الهاتف والبريد الإلكتروني')
            this.router.navigate([APP_ROUTES.AUTH.OTP]);
          }
        }
      );
    } else {
      this.authService
        .signin(this.selectedType, requestData)
        .subscribe((response: any) => {
          if (!this.sharedService?.isMock) {
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem('token', response.data.token);
          }
          this.toastr.success('! تم تسجيل الدخول بنجاح');
          this.layoutService.initializeSidebarListenners();
          this.router.navigate(['/']);
        });
    }

  }

  setRegisterType(choosedType: string) {
    // Handle transporter types
    if (choosedType === 'TRANSPORTER') {
      this.selectedType = this.userTypes.TRANSPORTER_AGENT;
    } else {
      this.selectedType = this.userTypes[choosedType] || this.userTypes.BUYER;
    }

    // Reinitialize the form
    this.loginForm = new FormGroup({
      phoneNumber: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(this.phoneLength),
          Validators.minLength(this.phoneLength)
        ]
      })
    });

    // Add additional fields based on user type
    if (this.showPasswordField()) {
      this.loginForm.addControl('pwd', new FormControl('', { validators: [Validators.required] }));
    }

    if (this.selectedType === this.userTypes.MARKETER) {
      this.loginForm.addControl('pairingCode', new FormControl('', { validators: [Validators.required] }));
    }
  }

  ngOnDestroy(): void {
    this.componentDestroyed$.complete();
  }
}